import React from "react";
import { storyblokEditable } from "@storyblok/react";
import Teaser from "./Teaser";
import ProductsListItem from "./ProductsListItem";

const ProductsList = ({ blok }) => {
    return (
        <section className="products-list" {...storyblokEditable(blok)}>
            {blok.h2_subtitle && blok.h2_subtitle.map(title => (
                <Teaser key={title._uid} blok={title}/>
            ))}
            <div className="products-list-container">
                {Object.keys(blok).map(key => {
                    if (key.startsWith("product_item_")) {
                        return blok[key].map(item => (
                            <ProductsListItem key={item._uid} blok={item} />
                        ));
                    }
                    return null;
                })}
            </div>
        </section>
    );
};

export default ProductsList;

